module.exports = __webpack_public_path__ + "img/4.06fb9a47.png";